import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import {toast} from "react-toastify";
import {RemoveDevicesZone} from "../../../../reduxToolkit/Devices/DevicesApi";
import {errorMsg} from "../../../../Apis/functions";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
export const TotalAccessMainApp =({setModified})=>{
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [modalShow, setModalShow] = useState(false);
    const [deleteDeviceShow, setDeleteDeviceShow] = useState(false);
    const [showLogModal, setShowLogModal] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    // Removes the selected devices from the zone, the device itself is kept
    const handleRemoveDevices = (uuids) => {
        dispatch(RemoveDevicesZone(uuids)).then(({ payload: { data: { success, code } } }) => {
            if (success) {
                setModified(true);
                toast.success(t('device_removed_success').toUpperCase());
            } else errorMsg(code);
        });
    };

    return {
        t,
        DEV,
        permission,
        setShowLogModal,
        setModalShow,
        setDeleteDeviceShow,
        modalShow,
        showLogModal,
        deleteDeviceShow,
        handleRemoveDevices
    }
}
